import type { RefObject } from "react";
import type { AvatarHandle } from "@/features/companion";
import { cn } from "@/lib/utils";
import {
  MarcusOnboardingCompactGuide,
  type MarcusOnboardingNextStepStatus,
} from "./MarcusOnboardingCompactGuide";
import { MarcusOnboardingIntroDialog } from "./MarcusOnboardingIntroDialog";
import { ONBOARDING_COPY } from "./marcusOnboardingIntroCopy";

export interface MarcusOnboardingIntroOverlayProps {
  open: boolean;
  voiceIntroActive: boolean;
  liveAvatarConnected: boolean;
  liveAvatarSpeaking: boolean;
  highlightLabel?: string | null;
  avatarRef: RefObject<AvatarHandle | null>;
  primaryActionLabel?: string;
  showNextButton?: boolean;
  nextStep?: MarcusOnboardingNextStepStatus | null;
  countdown?: number;
  onNext?: () => void;
  onAccept: () => void;
  onDismiss: () => void;
  onAvatarConnected: () => void;
  onAvatarDisconnected: () => void;
  onAvatarStartSpeaking: () => void;
  onAvatarStopSpeaking: () => void;
}

export function MarcusOnboardingIntroOverlay({
  open,
  voiceIntroActive,
  liveAvatarConnected,
  liveAvatarSpeaking,
  highlightLabel,
  avatarRef,
  primaryActionLabel = ONBOARDING_COPY.primaryAction,
  showNextButton = false,
  nextStep,
  countdown = 0,
  onNext,
  onAccept,
  onDismiss,
  onAvatarConnected,
  onAvatarDisconnected,
  onAvatarStartSpeaking,
  onAvatarStopSpeaking,
}: MarcusOnboardingIntroOverlayProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 z-[100]",
        open
          ? "flex items-start justify-center overflow-y-auto bg-foreground/35 px-4 py-4 backdrop-blur-[20px] sm:items-center sm:py-6"
          : "pointer-events-none",
      )}
    >
      {open ? (
        <MarcusOnboardingIntroDialog
          avatarRef={avatarRef}
          liveAvatarConnected={liveAvatarConnected}
          liveAvatarSpeaking={liveAvatarSpeaking}
          voiceIntroActive={voiceIntroActive}
          primaryActionLabel={primaryActionLabel}
          onAccept={onAccept}
          onDismiss={onDismiss}
          onAvatarConnected={onAvatarConnected}
          onAvatarDisconnected={onAvatarDisconnected}
          onAvatarStartSpeaking={onAvatarStartSpeaking}
          onAvatarStopSpeaking={onAvatarStopSpeaking}
        />
      ) : (
        <MarcusOnboardingCompactGuide
          avatarRef={avatarRef}
          voiceIntroActive={voiceIntroActive}
          liveAvatarConnected={liveAvatarConnected}
          liveAvatarSpeaking={liveAvatarSpeaking}
          highlightLabel={highlightLabel}
          showNextButton={showNextButton}
          nextStep={nextStep}
          countdown={countdown}
          onNext={onNext}
          onDismiss={onDismiss}
          onAvatarConnected={onAvatarConnected}
          onAvatarDisconnected={onAvatarDisconnected}
          onAvatarStartSpeaking={onAvatarStartSpeaking}
          onAvatarStopSpeaking={onAvatarStopSpeaking}
        />
      )}
    </div>
  );
}
